module.exports = __webpack_public_path__ + "img/Quantium Solution.63adbba1.png";